import * as React from 'react';
import { Config } from '../../Config';

interface IProps {
  name: string;
}

const TranslatedName = (props: IProps) => {
  const attribute = Config.dictionary.find(x => x.key == props.name);

  // Does key exist? If not, return key.
  if(!attribute) return <>{props.name}</>;
  
  return <>{attribute.text} {attribute.unit && <>({attribute.unit})</>}</>;
}

export { TranslatedName }
